/**
 * 主站部署 publicPath（构建期 VUE_APP_PUBLIC_PATH，开发默认 /）
 * 形如 /a1b2c3/ ；无隐蔽前缀时为 /
 */
export function getPublicPath() {
  const raw = process.env.VUE_APP_PUBLIC_PATH || '/'
  let p = String(raw).trim() || '/'
  if (!p.startsWith('/')) p = `/${p}`
  if (!p.endsWith('/')) p = `${p}/`
  return p
}

/** 将以 / 开头的站内绝对路径挂到 publicPath 下（/api/... → /PREFIX/api/...） */
export function withPublicPath(path) {
  const p = String(path || '')
  if (!p.startsWith('/')) return p
  const base = getPublicPath()
  if (base === '/') return p
  return `${base.replace(/\/$/, '')}${p}`
}
